angular.module('app')
	.controller('CarouselCtrl', function (
		$scope,
		$rootScope,
		$location,
		$translate,
		$configService,
		$window,
		$financialApiService,
		$userService,
		$timeout) {

		$scope.$configService = $configService;
		$scope.rootScope = $rootScope;
		$scope.window = $window;
		$scope.loadedMenu = false;
		$rootScope.showMessage = false;

		$rootScope.$on("showMessage", function (event, args) {
			$rootScope.showMessage = true;
			$rootScope.messageTextOverlay = args.text;
			$rootScope.classStyle = args.classStyle;
		});

		$scope.recoveryPassVisibility = false;
		$rootScope.homeIco = {
			title: 'Home',
			icon: "icon icon-home",
			className: 'home',
			path: '/',
			active: true,
			id: 'home'
		};
		$scope.recoveryPassVisibility = false;

		$scope.goTo = function (value) {
			if (value != null) {
				$location.path(value);
			}

		};

		$scope.initializeHeader = function () {
			$scope.$watch("appConfig.user.status", function (newValue, oldValue) {
				$scope.userStatus = oldValue;
				if ($configService.getAppConfig() != null &&
					$configService.getUser() != null &&
					!$configService.getUser().underVerification &&
					!$configService.getUser().impersonatingNdg &&
					($configService.getUserStatus() === propMap['USER_STATUS_RECOVERYPASSWORD'] || $configService.getUserStatus() === propMap['USER_STATUS_NEW_USER_R'] || $configService.getUserStatus() === propMap['USER_PASSWORD_EXPIRED'])) {
					$scope.openRecoveryPassword();
				}
			});

			$scope.$watch("cssPageName", function (newValue, oldValue) {
				if (!$rootScope.menuNavBar) {
					$rootScope.menuNavBar = $configService.getAppConfig().topMenu
				}
				initializeMainCarouselMenu();
				if ($rootScope.cssPageName == 'home') {
					$rootScope.homeIco.active = true;
					angular.forEach($rootScope.menuNavBar, function (singleItem) {

						singleItem.active = false;
					})
					self.checkMultiUser();
				} else {
					$rootScope.homeIco.active = false;

					angular.forEach($rootScope.menuNavBar, function (singleItem) {
						if (singleItem.relatedView == "/" + $rootScope.cssPageName) {
							singleItem.active = true;
						} else {
							singleItem.active = false;
						}
					});
				}
				if ($configService.getAppConfig() != null &&
					$configService.getUser() != null &&
					!$configService.getUser().underVerification &&
					!$configService.getUser().impersonatingNdg &&
					($configService.getUserStatus() === propMap['USER_STATUS_RECOVERYPASSWORD'] || $configService.getUserStatus() === propMap['USER_STATUS_NEW_USER_R'] || $configService.getUserStatus() === propMap['USER_PASSWORD_EXPIRED'])) {
					$scope.openRecoveryPassword();
				}
			});
		}

		$scope.changeActive = function (item) {
			if (item.id == 'home' && item.active == false) {
				item.active = true;
				angular.forEach($scope.menuNavBar, function (singleItem) {
					singleItem.active = false;
				});
			}

			if (item.active == false && item.id != 'home' && item.relatedView != null) {
				item.active = true;
				$rootScope.homeIco.active = false;
				angular.forEach($rootScope.menuNavBar, function (singleItem) {
					if (item.id != singleItem.id)
						singleItem.active = false;
				})
			}

		}

		$scope.clickIconOmino = function () {
			if ($configService.getUserStatus() != propMap['USER_STATUS_RECOVERYPASSWORD'] && $configService.getUserStatus() != propMap['USER_PASSWORD_EXPIRED']) {
				if (!$scope.recoveryPassVisibility) {
					$scope.openRecoveryPassword();
					$rootScope.isMenuDisabled = true;

				} else {
					$scope.clickCloseRecoveryPassword();
					$rootScope.isMenuDisabled = false;
				}
			}
		}

		$scope.openRecoveryPassword = function () {
			$scope.recoveryPassVisibility = true;
			$timeout(function () {
				pswRecoveryBlockNuArc();
			}, 500)
		}

		$scope.clickCloseRecoveryPassword = function () {
			$scope.recoveryPassVisibility = false;
			closePswRecovery();
		}

		$rootScope.setLanguage = function () {
			$translate.use(self.selectedItem);

		}

		$scope.openNavMenu = function () {
			$('.ui.labeled.icon.sidebar').sidebar('toggle');
		}

		self.checkMultiUser = function () {
			$userService
				.checkMultiUser()
				.then(function (response) {
					if (response) {
						$scope.checkMultiUser = true;
					} else {
						$scope.checkMultiUser = false;
					}
				})
				.catch(function (error) {
					console.log("ERROR", error);
				})
		}

		$scope.switchPortal = function () {
			$userService
				.switchPortal()
				.then(function (response) {
					if (response) {
						self.url = $location.$$absUrl.replace(/aru/gi, 'arf');
						window.location.replace(self.url);
					}
				})
				.catch(function (error) {
					console.log("ERROR", error);
				})
		}

	})